"use client";

import { useShowDeferredContent } from "@faire/web--source/common/deferredRender";
import React from "react";

import { TopOfPageContentWrapper } from "../../../Wrapper";

import { LightweightWrapper } from "./LightweightWrapper";

type Props = {
  children: React.ReactNode;
  hasNoTopBanner?: boolean;
  hasToastContainer?: boolean;
};

export const Wrapper: React.FC<Props> = ({ children, ...props }) => {
  const showDeferredContent = useShowDeferredContent();

  return showDeferredContent ? (
    <TopOfPageContentWrapper {...props}>{children}</TopOfPageContentWrapper>
  ) : (
    <LightweightWrapper {...props}>{children}</LightweightWrapper>
  );
};
